import {DocumentHeader} from '@sdox/ui'

import type {XcNwBlock_BlockDocumentHeaderType_Fragment} from '@sdox/api'

export const BlockDocumentHeader = (xcRecord: XcNwBlock_BlockDocumentHeaderType_Fragment) => {
  return (
    <DocumentHeader
      title={xcRecord.title}
      callout={xcRecord.callout}
    />
  )
}
